<template>
    <div>
        <card class='stripe-card'
              :class='{ complete }'
              :stripe='stripeToken'
              :options='stripeOptions'
              @change='complete = $event.complete'
        />

        <div class="columns m-t-md">
            <div class="column">
                <button
                    class="button"
                    @click="cancel()"
                    v-show="!savingCard"
                >
                    Cancel
                </button>
            </div>
            <div class="column has-text-right">
                <button
                    class='pay-with-stripe button is-primary'
                    :class="{ 'is-loading' : savingCard }"
                    @click='createStripeCard()'
                    :disabled='!complete'
                >
                    Add Card
                </button>
            </div>
        </div>
    </div>

</template>

<script>
import _ from "underscore";
import Stripe from "vue-stripe-elements-plus";
import Dealer from "@/api/Dealer";

export default {
    name : "StripeCard",
    components : {
        'card' : Stripe.Card,
    },
    props : {
        activeProvider : {
            type : Object,
            required : true,
        },
        ccMethod : {
            type : Object,
            required : true,
        }
    },
    data () {
        return {
            complete : false,
            savingCard : false,
            stripeOptions : {
                // see https://stripe.com/docs/stripe.js#element-options for details
            },
        }
    },
    computed : {
        stripeToken () {
            if(!this.activeProvider) {
                return null;
            }
            return _.findWhere(this.activeProvider.settings, { key : 'stripe_public_token' }).value;
        },
    },
    methods : {
        cancel () {
            this.$emit('cancel');
        },
        createStripeCard () {

            this.savingCard = true;

            Stripe.createSource({
                owner : {
                    email : this.$getDealer().email,
                    name : this.$getDealer().firstName + ' ' + this.$getDealer().lastName,
                },
                usage : 'reusable',
            }).then(async data => {

                const customer_token = await Dealer.postStripeAttachSource(data.source.id);

                if(!customer_token){
                    return Promise.reject();
                }

                this.$emit('create-payment-method', {
                    method : {
                        paymentProviderId : this.activeProvider.id,
                        paymentProviderMethodId : this.ccMethod.id,
                        last4 : data.source.card.last4,
                        metaData : JSON.stringify(data.source),
                    },
                    settings : [
                        {
                            key : 'stripe_source_token',
                            value : data.source.id,
                            accountPaymentProviderId : this.activeProvider.accountPaymentProvider.id,
                        },
                        {
                            key : 'stripe_customer_token',
                            value : customer_token,
                            accountPaymentProviderId : this.activeProvider.accountPaymentProvider.id,
                        }
                    ]
                });

            }).finally(() => {
                this.savingCard = false;
                this.complete = false;
            });
        },
    },
}
</script>

<style scoped>

</style>
